import { render, staticRenderFns } from "./FeedbackStep.vue?vue&type=template&id=0023b67c&scoped=true"
import script from "./FeedbackStep.vue?vue&type=script&lang=js"
export * from "./FeedbackStep.vue?vue&type=script&lang=js"
import style0 from "./FeedbackStep.vue?vue&type=style&index=0&id=0023b67c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0023b67c",
  null
  
)

export default component.exports